// Where Pino is drawn this frame, for anything that has to follow him.
//
// ServerNPCBridge already smooths his position and turn every frame and
// snaps him to the ground; this is that result, written once a frame, so
// the Pino cam (components/three/PinoCam.jsx) rides exactly the bird on
// screen instead of re-deriving him from the socket. A plain object on
// purpose: read every frame, never rendered from, so no store.
//
// And the newest thing in his bag, as its look (lib/things/looks.js), for
// the bubble over his head (components/three/npc/ThoughtBubble.jsx): written
// by the bridge only when it changes, so a new object here is a new thing
// and the same object is the same thing. null when his bag is empty.

export const birdPose = { x: 0, y: 0, z: 0, rotY: 0, action: null, seen: false, carrying: null, carryingKey: '' }
